import { CommonFunctions } from '../static/common-functions';
import { BaseBus } from './BaseBus';

export class InventoryPhotoBus extends BaseBus
{
  CID(): any {
      return this.inventoryPhotosId;
  }
    constructor() {
    super();
  }
    initialize(data: InventoryPhotoBus) {
    super.initialize(data);
    try {
        this.createdDate = CommonFunctions.getDate(data.createdDate);

    }
    catch {

    }

    }

    inventoryPhotosId: string;
    inventoryPhotoCategoryId: string;
    sequenceNumber: number;
    imageName: string;
    fileName?: string;
    description: string;
    visibleToCustomers: boolean;
    createdDate: Date;
    createdBy: string;
    inventoryId: any;

}
